export default __webpack_public_path__ + "assets/basic_content.4cca5a2d.svg";